<template>
    <v-card-title class="text-h4 font-weight-bold primary-text-color pb-2 pt-2 d-flex ga-2 align-center text-wrap">
        <v-icon v-if="icon" :size="size" :color="color" class="mr-2">
            {{ icon }}
        </v-icon>
        <span :id="id" class="align-self-center">{{ text }}</span>
        <div class="ml-auto">
            <slot />
        </div>
    </v-card-title>
    <v-divider thickness="4" class="grey lighten-2 rounded-sm"></v-divider>
</template>

<script setup lang="ts">
interface ICardTitle {
    color?: string;
    size?: string;
    icon?: string;
    text?: string;
    id?: string;
}

withDefaults(defineProps<ICardTitle>(), {
    color: 'secondary',
    size: '28'
});
</script>
